<template>
  <div class="wrong-container">
    <div class="header">
      <van-nav-bar
        title="错题详情"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      />
    </div>
    <div class="wrong-content" v-if="wrongList.length > 0">
      <div
        class="wrong-content-item"
        v-for="(item, index) in wrongList"
        :key="index"
      >
        <div class="wrong-content-item-title">
          {{ index + 1 }}.{{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { get } from "@/request.js";

const router = useRouter();
const route = useRoute();
const examHistoryId = ref("");
const parentId = ref("");
const wrongList = ref([]);
const onClickLeft = () => {
  // 🔥 修复：返回到课程详情页（考试列表）
  const registrationId = route.query?.registrationId;
  if (registrationId) {
    router.push({
      path: "/courseDetail",
      query: {
        id: registrationId,
        step: "3", // 确保显示考试步骤（步骤3）
      },
    });
  } else {
    // 如果没有 registrationId，使用默认返回
    router.back();
  }
};
const getWrongList = async () => {
  const res = await get(
    `/api/my/exam/histories/${parentId.value}/${examHistoryId.value}`
  );
  if (res.success) {
    wrongList.value = res.data || [];
  }
};
onMounted(() => {
  parentId.value = route.query.parentId;
  examHistoryId.value = route.query.examHistoryId;
  getWrongList();
});
</script>
<style scoped lang="less">
.wrong-container {
  min-height: 100vh;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  .wrong-content {
    padding: 10px;
    margin: 10px;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

    .wrong-content-item {
      border-radius: 10px;
      padding: 5px 0;
      margin-bottom: 10px;
      border-bottom: 1px solid #f0f0f0;
      &:last-child {
        border-bottom: none;
      }

      .wrong-content-item-title {
        font-size: 16px;
        color: #333;
        padding: 10px;
      }
    }
  }
}
</style>
